import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getReservationRules, updateReservationRules } from './api';
import { reservationRulesKeys } from './keys';
import { UpdateReservationRulesBody } from './types';

export const useReservationRules = ({ centerId, enabled = true }: { centerId: string; enabled?: boolean }) =>
    useQuery({
        queryKey: reservationRulesKeys.detail(centerId),
        queryFn: () => getReservationRules(centerId),
        enabled: enabled && !!centerId,
        select: (data) => {
            const rules = data?.data?.rules;
            if (!rules) return null;
            // 백엔드에 빠진 필드 기본값 보정
            return {
                ...rules,
                sameDayBookingEnabled: rules.sameDayBookingEnabled ?? false,
                sameDayBookingDeadline: rules.sameDayBookingDeadline ?? 120,
            };
        },
    });

export const useUpdateReservationRules = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ centerId, body }: { centerId: string; body: UpdateReservationRulesBody }) => updateReservationRules(centerId, body),
        onSuccess: (_, v) => { qc.invalidateQueries({ queryKey: reservationRulesKeys.detail(v.centerId) }); },
    });
};
